/**
 * @file PageEditingNotice.tsx
 * @description Плашка «Страницу сейчас правит Анна (5 мин назад)…»
 * (phase19.16 Р3а; SB126 «Одновременная правка»): последняя правка
 * черновика чужая и не старше 10 минут (порог shared
 * `SITE_PAGE_EDITING_WINDOW_MS`). Живого присутствия нет — пересчёт раз в
 * минуту, чтобы плашка ушла сама.
 */

import { useEffect, useState } from "react";

import { NoticeStrip } from "../../ui/NoticeStrip";
import { useSiteView } from "../../site-view/site-view-context";
import type { SitePageDraftState } from "../../../lib/api-site-page-publish";
import { editingNoticeText } from "../../../lib/site-builder/page-status";

export function PageEditingNotice({ draft }: { draft: SitePageDraftState }) {
  const view = useSiteView();
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(timer);
  }, []);
  const text = editingNoticeText(draft, view.currentUserId, now);
  return text ? <NoticeStrip tone="warning">{text}</NoticeStrip> : null;
}
